"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var provider;
        (function (provider) {
            var edit;
            (function (edit) {
                class InitArgs {
                    constructor() {
                        this.extraUserInfoDataSources = [];
                        this.staticValue = appn.emptyString;
                        this.dataSourcesAjaxGetDataSourceHeaders = appn.emptyString;
                        this.dataSourcesAjaxGetDataSourceColumnValues = appn.emptyString;
                        this.providerAjaxUnassignConsultant = appn.emptyString;
                        this.consultant = appn.emptyString;
                        this.userAuditUrl = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    appn.dialog.showBillUpgradeOnClick(function () {
                        $('#Provider_ProviderConfig_EnableUserApiKeys').prop('checked', false);
                    });
                    populateDsColumnsOnLoad();
                    appn.select.init({ selector: '#externalAuthREST select.formatType', omitWidth: true });
                    if ($('#IsRetireNow').is(':checked'))
                        checkRetireOnDialog('IsRetireNow');
                    else
                        checkRetireOnDialog();
                }
                edit.init = init;
                function addEvents() {
                    $('input[name=logoFile],input[name=headfile]').on('change', function (event) {
                        const f = event.target.files[0];
                        if (!f)
                            return false;
                        const isValidExt = appn.utils.isValidFileExtension(['png'], f.name);
                        const isValidSize = appn.utils.IsValidFileSize(3000, f);
                        if (!isValidExt || !isValidSize) {
                            const that = this;
                            setTimeout(function () {
                                $(that).closest('.fileinput').find('.btn.btn-remove').click();
                            }, 500);
                        }
                        return false;
                    });
                    $('.viewUserAudit').click(function () {
                        appn.iframe.openModal({
                            url: `${_initArgs.userAuditUrl}`,
                            size: 'modal-xl'
                        });
                    });
                    $('.editSecretKey').click(function (event) {
                        event.preventDefault();
                        const connectionCard = $(this).closest('.card');
                        connectionCard.find('.maskedSecretKey').hide();
                        connectionCard.find('.editSecretKey').hide();
                        connectionCard.find('.input-secretkey').fadeIn();
                    });
                    $(document).on('click', '.addMetaItem', function (event) {
                        event.preventDefault();
                        const table = $('#metaData');
                        const idx = table.find('tbody tr').length;
                        const newRow = `<tr>` +
                            `<td class="dataCol name"><input class="form-control form-control-sm metaDataKey" type="text" name="Provider.MetaData[${idx}].Key" class="valid"></td>` +
                            `<td class="dataCol value"><input class="form-control form-control-sm metaDataVal" type="text" name="Provider.MetaData[${idx}].Val" class="valid"></td>` +
                            `<td class="closeCell">${appn.elementBuilder.buildBtnRemoveRow('delete_button_metaData')}</td>` +
                            `</tr>`;
                        table.find('tbody').append(newRow);
                        if (table.find('tbody tr').length > 0)
                            table.show();
                    });
                    $(document).on('click', '.delete_button_metaData', function () {
                        const table = $('#metaData');
                        $(this).closest('tr').remove();
                        renameRows(table.attr('id'));
                        if (table.find('tbody tr').length === 0)
                            table.hide();
                    });
                    $(document).on('click', '.addExtraUserInfoItem', function (event) {
                        event.preventDefault();
                        const table = $('#extraUserInfo');
                        const idx = table.find('tbody tr').length;
                        const newRow = `<tr>` +
                            `<td class="dataCol fieldId d-none"><input class="extraUserInfoFieldId" type="hidden" name="Provider.ProviderConfig.ExtraUserInfo[${idx}].Id" id="Provider_ProviderConfig_ExtraUserInfo_${idx}__Id" value="${appn.utils.newGuid()}"></td>` +
                            `<td class="dataCol fieldName"><input class="form-control form-control-sm extraUserInfoFieldName" type="text" name="Provider.ProviderConfig.ExtraUserInfo[${idx}].FieldName" id="Provider_ProviderConfig_ExtraUserInfo_${idx}__FieldName"></td>` +
                            `<td class="dataCol dataSourceId">${appn.elementBuilder.buildSelect(_initArgs.extraUserInfoDataSources, `Provider_ProviderConfig_ExtraUserInfo_${idx}__DataSourceId`, 'extraUserInfoDataSource', '', `Provider.ProviderConfig.ExtraUserInfo[${idx}].DataSourceId`)}${appn.elementBuilder.buildSelect([{ disabled: false, selected: false, text: '...', value: 'dotdotdot' }], `Provider_ProviderConfig_ExtraUserInfo_${idx}__DataSourceColRowIdentifier`, 'extraUserInfoDataSourceColRowIdentifier d-none', '', `Provider.ProviderConfig.ExtraUserInfo[${idx}].DataSourceColRowIdentifier`)}</td>` +
                            `<td class="dataCol defaultValue"><input class="form-control form-control-sm extraUserInfoDefaultValue" type="text" name="Provider.ProviderConfig.ExtraUserInfo[${idx}].DefaultValue" id="Provider_ProviderConfig_ExtraUserInfo_${idx}__DefaultValue" class="extraUserInfoDefaultValue form-control-sm">${appn.elementBuilder.buildSelect([{ disabled: false, selected: false, text: 'Choose...', value: appn.emptyString }], `Provider_ProviderConfig_ExtraUserInfo_${idx}__DefaultValueFromDsRow`, 'form-control-sm extraUserInfoDefaultValueFromDsRow d-none', '', `Provider.ProviderConfig.ExtraUserInfo[${idx}].DefaultValueFromDsRow`)}</td>` +
                            `<td class="dataCol required">${appn.elementBuilder.buildCheckbox('', 'extraUserInfoRequired form-control-sm', `Provider_ProviderConfig_ExtraUserInfo[${idx}]_Required`, appn.elementBuilder.ICheckColor.primary, `Provider.ProviderConfig.ExtraUserInfo[${idx}].Required`, true)}</td>` +
                            `<td class="closeCell">${appn.elementBuilder.buildBtnRemoveRow('delete_button_extraUserInfo')}</td>` +
                            `</tr>`;
                        table.find('tbody').append(newRow);
                        if (table.find('tbody tr').length > 0)
                            table.show();
                        initExtraUserInfoSelects();
                        extraUserInfoDataSourceId_onChange();
                        extraUserInfoDataSourceColRowIdentifier_onChange();
                    });
                    $(document).on('click', '.delete_button_extraUserInfo', function (event) {
                        event.preventDefault();
                        const tableId = $(this).closest('table').attr('id');
                        const table = $('#extraUserInfo');
                        $(this).closest('tr').remove();
                        renameRows(tableId);
                        if (table.find('tbody tr').length === 0)
                            table.hide();
                    });
                    $(document).on('click', '.addCustomCategory', function (event) {
                        event.preventDefault();
                        const table = $('#customCategories');
                        const idx = table.find('tbody tr').length;
                        const newRow = `<tr>` +
                            `<td class="dataCol name"><input class="form-control form-control-sm categoryName" type="text" name="Provider.ProviderConfig.CustomRepositoryCategories[${idx}]" class="valid"></td>` +
                            `<td class="closeCell">${appn.elementBuilder.buildBtnRemoveRow('delete_button_customCategory')}</td>` +
                            `</tr>`;
                        table.find('tbody').append(newRow);
                        if (table.find('tbody tr').length > 0)
                            table.showElement();
                    });
                    $(document).on('click', '.delete_button_customCategory', function () {
                        const deleteBtn = $(this);
                        const tableId = deleteBtn.closest('table').attr('id');
                        const table = $(`#${tableId}`);
                        const isPromptDelete = deleteBtn.hasClass('prompt-delete');
                        const rowIndex = deleteBtn.closest('tr').index();
                        const rowId = `#Provider_ProviderConfig_CustomRepositoryCategories_${rowIndex}_`;
                        var selectedCategoryText = $(rowId).val();
                        if (!isPromptDelete) {
                            deleteBtn.closest('tr').remove();
                            renameRows(tableId);
                            if (table.find('tbody tr').length === 0)
                                table.hideElement();
                            return;
                        }
                        appn.dialog.confirm({
                            modalColor: 'modal-danger',
                            title: T('Deleting a Custom Category'),
                            message: T(`You are about to delete the '{0}' category, which belongs to several other Repository items. If you're unsure, please view the Examples Catalog. If you wish to continue, you will not be able to assign anything new to '{0}'.<br>We won't remove '{0}' from the Examples Catalog until each item is removed.`, selectedCategoryText),
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('OK') + '</span>',
                                    className: 'btn-success'
                                }
                            },
                            isDeleteAction: true,
                            callback: function (result) {
                                if (result) {
                                    deleteBtn.closest('tr').remove();
                                    renameRows(tableId);
                                    if (table.find('tbody tr').length === 0)
                                        table.hideElement();
                                }
                                return;
                            }
                        });
                    });
                    $('.unassignConsultant').on('click', function () {
                        const warningParagraph = T('If you unassign <b>{0}</b> as your consultant, they will no longer be able to access your platform to assist you with development or maintenance.', _initArgs.consultant) + '<br><br>';
                        const warningParagraphElement = appn.elementBuilder.createElement('p', undefined, undefined, undefined, warningParagraph);
                        const warningText = T('Do you wish to <b>unassign</b> this Consultant?');
                        const warningTextElement = appn.elementBuilder.createElement('p', 'text-center', undefined, undefined, warningText);
                        const unassignMsg = appn.elementBuilder.createElement('div');
                        unassignMsg.appendChild(warningParagraphElement);
                        unassignMsg.appendChild(warningTextElement);
                        appn.dialog.custom({
                            modalColor: 'modal-danger',
                            title: T('Unassign Consultant'),
                            message: unassignMsg,
                            closeButton: true,
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('Unassign') + '</span>',
                                    className: 'btn-success',
                                    callback: function (result) {
                                        if (!result)
                                            return;
                                        appn.ajax.post({
                                            url: _initArgs.providerAjaxUnassignConsultant,
                                            done: function (data) {
                                                const dataParsed = JSON.parse(data);
                                                if (!dataParsed.Success) {
                                                    appn.toast.notify(appn.toast.Type.error, dataParsed.Message);
                                                    return;
                                                }
                                                $('.unassignConsultant').closest('.form-group').remove();
                                                appn.toast.notify(appn.toast.Type.info, dataParsed.Message);
                                            },
                                            fail: function () {
                                                appn.toast.notify(appn.toast.Type.error, T('Failed to unassign consultant.'));
                                            }
                                        });
                                    }
                                }
                            }
                        });
                    });
                    $('button[id="unretire"]').on('click', function (event) {
                        event.stopPropagation();
                        const retireDate = $(this).closest('label').text();
                        appn.dialog.confirm({
                            title: T('Cancel Scheduled Retirement?'),
                            message: T('This will cancel the retirement of this organization scheduled for {0}.', retireDate),
                            className: 'confirm-cancel-retirement',
                            buttons: {
                                confirm: {
                                    label: T('Proceed'),
                                    className: 'btn-success'
                                },
                                cancel: {
                                    label: T('Close')
                                }
                            },
                            callback: function (result) {
                                if (!result)
                                    return;
                                const form = appn.ui.getMainContentForm();
                                form.append(`<input type="hidden" name="submitType" value="CancelRetire" />`);
                                form.submit();
                            }
                        });
                    });
                    $('#IsRetireNow,#IsRetireOn').on('change', function (event) {
                        const selfId = event.target.id;
                        const clickedBox = $(`#${selfId}`);
                        const otherId = selfId === 'IsRetireNow' ? 'IsRetireOn' : 'IsRetireNow';
                        const otherBox = $(`#${otherId}`);
                        clickedBox.prop('checked', true);
                        $(`input[name="${selfId}"]`).val('true');
                        otherBox.prop('checked', false);
                        $(`input[name="${otherId}"]`).val('false');
                        checkRetireOnDialog(selfId);
                    });
                    extraUserInfoDataSourceId_onChange();
                    extraUserInfoDataSourceColRowIdentifier_onChange();
                }
                function checkRetireOnDialog(id = 'IsRetireOn') {
                    if (id === 'IsRetireOn') {
                        $('#RetireOnDate').closest('.date-input').showElement();
                        $('#modalRetireButton').attr('value', 'RetireOn');
                    }
                    else {
                        $('#RetireOnDate').closest('.date-input').hideElement();
                        $('#modalRetireButton').attr('value', 'Retire');
                    }
                }
                function extraUserInfoDataSourceId_onChange() {
                    $('.extraUserInfoDataSource').off().on('change', function (event) {
                        event.preventDefault();
                        const val = $(this).val();
                        const currentRow = $(this).closest('tr');
                        const dataSourceColRowIdentifier = currentRow.find('.extraUserInfoDataSourceColRowIdentifier');
                        const dataSourceId = currentRow.find('.extraUserInfoDataSource');
                        const defaultValue = currentRow.find('.extraUserInfoDefaultValue');
                        const defaultValueFromDsRow = currentRow.find('.extraUserInfoDefaultValueFromDsRow');
                        if (val === _initArgs.staticValue) {
                            dataSourceColRowIdentifier.removeClass('d-none').addClass('d-none');
                            dataSourceId.removeClass('d-none');
                            defaultValue.removeClass('d-none');
                            defaultValueFromDsRow.removeClass('d-none').addClass('d-none');
                            initExtraUserInfoSelects();
                            return;
                        }
                        dataSourceId.removeClass('d-none').addClass('d-none');
                        dataSourceColRowIdentifier.removeClass('d-none');
                        defaultValueFromDsRow.removeClass('d-none');
                        defaultValue.removeClass('d-none').addClass('d-none');
                        getDsColumns(val, dataSourceId, dataSourceColRowIdentifier);
                    });
                }
                function populateDsColumnsOnLoad() {
                    $.each($('table#extraUserInfo tbody tr'), function (index, tr) {
                        const dataSourceId = $(tr).find('.extraUserInfoDataSource');
                        const dataSourceColRowIdentifier = $(tr).find('.extraUserInfoDataSourceColRowIdentifier');
                        if (dataSourceId.val() === _initArgs.staticValue)
                            return true;
                        getDsColumns(dataSourceId.val(), dataSourceId, dataSourceColRowIdentifier);
                    });
                }
                function getDsColumns(dsId, dataSourceId, dataSourceColRowIdentifier) {
                    const closestTd = dataSourceId.closest('td');
                    appn.ui.spinnerInject(closestTd);
                    dataSourceColRowIdentifier.removeClass('d-none').addClass('d-none');
                    dataSourceColRowIdentifier.html('');
                    appn.ajax.get({
                        url: appn.location.buildUrlWithQueryString(_initArgs.dataSourcesAjaxGetDataSourceHeaders, [{ name: 'dsId', value: dsId }]),
                        done: function (data) {
                            if (!data) {
                                appn.toast.notify(appn.toast.Type.warning, T('No column data found for ') + dataSourceId.val());
                                dataSourceId.val(_initArgs.staticValue);
                                return;
                            }
                            dataSourceColRowIdentifier.html(appn.elementBuilder.buildOptionsListSelectList(data, appn.emptyString, { groupName: dataSourceId.find('option:selected').text(), startIndex: 1, endIndex: data.length }));
                            const selectedValueFromServer = dataSourceColRowIdentifier.attr('selectedValue');
                            dataSourceColRowIdentifier.attr('selectedValue', appn.emptyString);
                            if (!selectedValueFromServer) {
                                const firstValueInColIdentifierSelect = dataSourceColRowIdentifier.find('option:nth-child(2)').val();
                                if (!firstValueInColIdentifierSelect) {
                                    dataSourceId.val(_initArgs.staticValue);
                                    return;
                                }
                                dataSourceColRowIdentifier.val(firstValueInColIdentifierSelect);
                                dataSourceColRowIdentifier.trigger('change');
                                return;
                            }
                            dataSourceColRowIdentifier.val(selectedValueFromServer);
                            dataSourceColRowIdentifier.trigger('change');
                        },
                        fail: function () {
                            appn.toast.notify(appn.toast.Type.error, T('Error fetching column data.'));
                        },
                        always: function () {
                            appn.ui.spinnerRemove(closestTd);
                            dataSourceColRowIdentifier.removeClass('d-none');
                            initExtraUserInfoSelects();
                        }
                    });
                }
                function getDsColumnValues(dsId, dataSourceId, defaultValueFromDsRow, columnName) {
                    const closestTd = defaultValueFromDsRow.closest('td');
                    appn.ui.spinnerInject(closestTd);
                    defaultValueFromDsRow.removeClass('d-none').addClass('d-none');
                    defaultValueFromDsRow.html(appn.emptyString);
                    appn.ajax.get({
                        url: appn.location.buildUrlWithQueryString(_initArgs.dataSourcesAjaxGetDataSourceColumnValues, [{ name: 'dsId', value: dsId }, { name: 'columnName', value: columnName }]),
                        done: function (data) {
                            if (!data) {
                                appn.toast.notify(appn.toast.Type.warning, T('No column data found for ') + dataSourceId.val());
                                dataSourceId.val(_initArgs.staticValue);
                                return;
                            }
                            defaultValueFromDsRow.html(appn.elementBuilder.buildOptionsListSelectList(data));
                            const selectedValueFromServer = defaultValueFromDsRow.attr('selectedValue');
                            defaultValueFromDsRow.attr('selectedValue', appn.emptyString);
                            defaultValueFromDsRow.val(selectedValueFromServer);
                        },
                        fail: function () {
                            appn.toast.notify(appn.toast.Type.error, T('Error fetching column value data.'));
                        },
                        always: function () {
                            appn.ui.spinnerRemove(closestTd);
                            defaultValueFromDsRow.removeClass('d-none');
                            initExtraUserInfoSelects();
                        }
                    });
                }
                function initExtraUserInfoSelects() {
                    appn.select.init({ selector: '#extraUserInfo select' });
                    appn.ui.checkboxForceOnChanged('.extraUserInfoRequired');
                }
                function extraUserInfoDataSourceColRowIdentifier_onChange() {
                    $('.extraUserInfoDataSourceColRowIdentifier').off().on('change', function (event) {
                        event.preventDefault();
                        const val = $(this).val();
                        const currentRow = $(this).closest('tr');
                        const dataSourceColRowIdentifier = currentRow.find('.extraUserInfoDataSourceColRowIdentifier');
                        const dataSourceId = currentRow.find('.extraUserInfoDataSource');
                        const defaultValue = currentRow.find('.extraUserInfoDefaultValue');
                        const defaultValueFromDsRow = currentRow.find('.extraUserInfoDefaultValueFromDsRow');
                        if (!val || val === 'dotdotdot') {
                            dataSourceColRowIdentifier.removeClass('d-none').addClass('d-none');
                            dataSourceId.removeClass('d-none');
                            defaultValueFromDsRow.removeClass('d-none').addClass('d-none');
                            defaultValue.removeClass('d-none');
                            dataSourceId.val(_initArgs.staticValue);
                            initExtraUserInfoSelects();
                            return;
                        }
                        dataSourceId.removeClass('d-none').addClass('d-none');
                        dataSourceColRowIdentifier.removeClass('d-none');
                        defaultValue.removeClass('d-none').addClass('d-none');
                        defaultValueFromDsRow.removeClass('d-none');
                        getDsColumnValues(dataSourceId.val(), dataSourceId, defaultValueFromDsRow, dataSourceColRowIdentifier.val());
                    });
                }
                function deleteExtraUserInfo(_this) {
                    const tableName = _this.attr('data-tablename');
                    _this.parents('tr').remove();
                    renameRows(tableName);
                    if ($('#extraUserInfo tbody').children().length === 0) {
                        $('#extraUserInfo').hide();
                        $('.addExtraUserInfoItem').css('top', '-20px');
                    }
                }
                function addExtraUserInfoItem() {
                    if ($('#extraUserInfo tbody').children().length === 0) {
                        $('#extraUserInfo').show();
                        $('.addExtraUserInfoItem').css('top', '0px');
                    }
                    const idx = $('#extraUserInfo tbody').children().length;
                    const newRow = `<tr>` +
                        `<td class="dataCol fieldId d-none"><input class="extraUserInfoFieldId" type="hidden" name="Provider.ProviderConfig.ExtraUserInfo[${idx}].Id" id="Provider_ProviderConfig_ExtraUserInfo_${idx}__Id" value="${appn.utils.newGuid()}"></td>` +
                        `<td class="dataCol fieldName"><input class="form-control form-control-sm extraUserInfoFieldName" type="text" name="Provider.ProviderConfig.ExtraUserInfo[${idx}].FieldName" id="Provider_ProviderConfig_ExtraUserInfo_${idx}__FieldName"></td>` +
                        `<td class="dataCol dataSourceId">${appn.elementBuilder.buildSelect(_initArgs.extraUserInfoDataSources, `Provider_ProviderConfig_ExtraUserInfo_${idx}__DataSourceId`, 'extraUserInfoDataSource', '', `Provider.ProviderConfig.ExtraUserInfo[${idx}].DataSourceId`)}${appn.elementBuilder.buildSelect([{ disabled: false, selected: false, text: '...', value: 'dotdotdot' }], `Provider_ProviderConfig_ExtraUserInfo_${idx}__DataSourceColRowIdentifier`, 'extraUserInfoDataSourceColRowIdentifier d-none', '', `Provider.ProviderConfig.ExtraUserInfo[${idx}].DataSourceColRowIdentifier`)}</td>` +
                        `<td class="dataCol defaultValue"><input class="form-control form-control-sm extraUserInfoDefaultValue" type="text" name="Provider.ProviderConfig.ExtraUserInfo[${idx}].DefaultValue" id="Provider_ProviderConfig_ExtraUserInfo_${idx}__DefaultValue" class="extraUserInfoDefaultValue form-control-sm">${appn.elementBuilder.buildSelect([{ disabled: false, selected: false, text: T('Choose...'), value: appn.emptyString }], `Provider_ProviderConfig_ExtraUserInfo_${idx}__DefaultValueFromDsRow`, 'form-control-sm extraUserInfoDefaultValueFromDsRow d-none', '', `Provider.ProviderConfig.ExtraUserInfo[${idx}].DefaultValueFromDsRow`)}</td>` +
                        `<td class="dataCol required">${appn.elementBuilder.buildCheckbox('', 'extraUserInfoRequired form-control-sm', `Provider_ProviderConfig_ExtraUserInfo[${idx}]_Required`, appn.elementBuilder.ICheckColor.primary, `Provider.ProviderConfig.ExtraUserInfo[${idx}].Required`, true)}</td>` +
                        `<td class="closeCell">${appn.elementBuilder.buildBtnRemoveRow('delete_button_extraUserInfo', 'data-tablename="extraUserInfo"')}</td>` +
                        `</tr>`;
                    $('#extraUserInfo tbody').append(newRow);
                    initExtraUserInfoSelects();
                    extraUserInfoDataSourceId_onChange();
                    extraUserInfoDataSourceColRowIdentifier_onChange();
                }
                function renameRows(tableName) {
                    if (tableName === 'metaData')
                        renameMetaData();
                    if (tableName === 'extraUserInfo')
                        renameExtraUserInfoRows();
                    if (tableName === 'customCategories')
                        renameCustomCategories(tableName);
                }
                function renameMetaData() {
                    $('#metaData tbody tr').each(function (index, row) {
                        $(this).find('.metaDataKey')
                            .attr('name', `Provider.MetaData[${index}].Key`);
                        $(this).find('.metaDataVal')
                            .attr('name', `Provider.MetaData[${index}].Val`);
                    });
                }
                function renameCustomCategories(tableId) {
                    $(`#${tableId} tbody tr`).each(function (index, row) {
                        $(this).find('.categoryName')
                            .attr('name', `Provider.ProviderConfig.CustomRepositoryCategories[${index}]`);
                    });
                }
                function renameExtraUserInfoRows() {
                    $('#extraUserInfo tbody tr').each(function (index, row) {
                        $(this).find('.extraUserInfoFieldId')
                            .attr('name', `Provider.ProviderConfig.ExtraUserInfo[${index}].Id`)
                            .attr('id', `Provider_ProviderConfig_ExtraUserInfo_${index}__Id`);
                        $(this).find('.extraUserInfoFieldName')
                            .attr('name', `Provider.ProviderConfig.ExtraUserInfo[${index}].FieldName`)
                            .attr('id', `Provider_ProviderConfig_ExtraUserInfo_${index}__FieldName`);
                        $(this).find('.extraUserInfoDataSource')
                            .attr('name', `Provider.ProviderConfig.ExtraUserInfo[${index}].DataSourceId`)
                            .attr('id', `Provider_ProviderConfig_ExtraUserInfo_${index}__DataSourceId`);
                        $(this).find('.extraUserInfoDataSourceColRowIdentifier')
                            .attr('name', `Provider.ProviderConfig.ExtraUserInfo[${index}].DataSourceColRowIdentifier`)
                            .attr('id', `Provider_ProviderConfig_ExtraUserInfo_${index}__DataSourceColRowIdentifier`);
                        $(this).find('.extraUserInfoDefaultValue')
                            .attr('name', `Provider.ProviderConfig.ExtraUserInfo[${index}].DefaultValue`)
                            .attr('id', `Provider_ProviderConfig_ExtraUserInfo_${index}__DefaultValue`);
                        $(this).find('.extraUserInfoDefaultValueFromDsRow')
                            .attr('name', `Provider.ProviderConfig.ExtraUserInfo[${index}].DefaultValueFromDsRow`)
                            .attr('id', `Provider_ProviderConfig_ExtraUserInfo_${index}__DefaultValueFromDsRow`);
                        $(this).find('.dataCol.required .extraUserInfoRequired')
                            .attr('name', `Provider.ProviderConfig.ExtraUserInfo[${index}].Required`);
                        $(this).find('.dataCol.required input[type="hidden"]')
                            .attr('name', `Provider.ProviderConfig.ExtraUserInfo[${index}].Required`);
                    });
                }
            })(edit = provider.edit || (provider.edit = {}));
        })(provider = views.provider || (views.provider = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
